<template>
    <div class="explain">
        <div class="layer">
            <Search />
        </div>
        <div class="layer">
            <SuperNav :list="headerNav"/>
        </div>
        <div class="nav_bottom"></div>
        <div class="layer mt30px clearfix">
            <LeftNav class="fl mt10" />
            <div class="detail fl mt10">
                <keep-alive>
                    <router-view class="ml30"></router-view>
                </keep-alive>
            </div>
        </div>

    </div>
</template>

<script>
import Search from '@/components/Search/index'
import SuperNav from '@/components/SuperNav/index'
import LeftNav from './leftNav'
import { HomeService } from '../../service/home.service';
export default {
    data() {
        return {
            headerNav: []
        }
    },
    components: {
        Search,
        SuperNav,
        LeftNav
    },
    async created() {
        const { headerNav } = await HomeService.shopIndex();
        this.headerNav = headerNav;
    }
}
</script>

<style lang="scss">
    .explain .router-link-active .el-menu-item{
        background: #fff!important;
        
    }
</style>